const keys = {
  MONDAY: {
    key: 'MONDAY',
    description: 'Segunda',
    value: 1,
    color: '#f5f5f5',
  },
  TUESDAY: {
    key: 'TUESDAY',
    description: 'Terça',
    value: 2,
    color: '',
  },
  WEDNESDAY: {
    key: 'WEDNESDAY',
    description: 'Quarta',
    value: 3,
    color: '#f5f5f5',
  },
  THURSDAY: {
    key: 'THURSDAY',
    description: 'Quinta',
    value: 4,
    color: '',
  },
  FRIDAY: {
    key: 'FRIDAY',
    description: 'Sexta',
    value: 5,
    color: '#f5f5f5',
  },
  SATURDAY: {
    key: 'SATURDAY',
    description: 'Sábado',
    value: 6,
    color: '',
  },
  SUNDAY: {
    key: 'SUNDAY',
    description: 'Domingo',
    value: 0,
    color: '#f5f5f5',
  },
};

const values = Object.keys(keys)
  .map((key) => keys[key]);

export default {
  keys,
  values,
};
